import { Trans, useTranslation } from 'react-i18next';

import { RankMovement } from './RankMovement';
import styles from './RankSection.module.scss';

interface RankSectionProps {
  companyName: string;
  targetName: string;
  rank: number;
  rankChange?: number | null;
  description: string;
}

export const RankSection = ({
  companyName,
  targetName,
  rank,
  rankChange,
  description,
}: RankSectionProps) => {
  const { t } = useTranslation(['widget']);

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <Trans
          t={t}
          i18nKey={
            rankChange != null
              ? 'widget:assetOverview.knowledgeGraph.isRankedIn'
              : 'widget:assetOverview.knowledgeGraph.withoutRankChange'
          }
          values={{ companyName, rank, targetName }}
          components={{
            rank: <span className={styles.rank} />,
            ...(rankChange != null
              ? { movement: <RankMovement change={rankChange} /> }
              : {}),
          }}
        />
      </div>
      <div className={styles.description}>{description}</div>
    </div>
  );
};
